import type { ReminderSettings } from '@/core/domain';
import type { ReminderSettingsRepository } from '../repositories/reminder-settings-repository';

export class UpdateReminderSettingsUseCase {
  constructor(private readonly repository: ReminderSettingsRepository) {}

  async execute(userId: string, id: string, settings: Partial<ReminderSettings>): Promise<ReminderSettings> {
    return this.repository.update(userId, id, settings);
  }
}
